<div class="container-fluid">
  <div>
    <div class="row   justify-content-start mb-2">
      <div class="col-9">
        <span class="iso-header ml-2">
          {{'bikeshop.menu.message_templates' | translate}}
        </span>
      </div>
      <div class="col-3 justify-content-end d-flex">
        <daz-icon class="iso-search-icon" [name]="'search'" [size]="'22px'" [color]="'#888888'"></daz-icon>
        <input (keyup)="searchSettings()" [(ngModel)]="userSearchTerm" class="iso-search-bar" type="text"
          placeholder="Search">
        <!--        -->

      </div>
    </div>

    <div *ngIf="loading" style="margin-top: 32px;display: flex;justify-content: center;">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>

    <div class="row" *ngIf="!loading">
      <div class="col">
        <p-accordion class="iso-accordion" [multiple]="true">
          <div *ngIf="isWorkshop">
            <p-accordionTab *ngIf="this.getServiceTemplates().length > 0" [selected]="isExpanded"
              class="iso-accordion-tab" header="{{'bikeshop.message_templates.services' | translate}}">
              <table class="table iso-table">
                <tbody>
                  <tr *ngFor="let messageTemplate of getServiceTemplates()"
                    (click)="selectMessageType(messageTemplate)">
                    <td>
                      <div>
                        {{ appConfig.getCustomLabelForMessageTag(messageTemplate.EventTag, (messageTemplate.EventTag +
                        '_title'
                        | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:
                        partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours,
                        OtherServiceFollowUpReminderMonths: partner.OtherServiceFollowUpReminderMonths,
                        PostServiceFollowUpDays: partner.PostServiceFollowUpDays
                        }), false) }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <span class="hubtiger-mail" [ngClass]="{'configured' : messageTemplate.IsActive}"></span>
                        <span class="hubtiger-sms"
                          [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                        <span class="hubtiger-whatsapp" *ngIf="whatsappConfiguredEnabled"
                          [ngClass]="{ 'not-syncd' : messageTemplate.WhatsappActive && !messageTemplate.WAStatus, 'configured' : messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'APPROVED', 'rejected':  messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'REJECTED', 'pending' : messageTemplate.WhatsappActive && messageTemplate.WAStatus && messageTemplate.WAStatus !== 'APPROVED' && messageTemplate.WAStatus !== 'REJECTED'}"></span>
                      </div>
                    </td>
                    <td>
                      <div>
                        {{
                        appConfig.getCustomLabelForMessageTag(messageTemplate.EventTag, (messageTemplate.EventTag
                        + '_description' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths,
                        ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
                        WaitingDelayHours: partner.WaitingDelayHours,
                        OtherServiceFollowUpReminderMonths:
                        partner.OtherServiceFollowUpReminderMonths,
                        PostServiceFollowUpDays: partner.PostServiceFollowUpDays
                        }), true)
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
            <p-accordionTab [selected]="isExpanded" *ngIf="getBikeFittingsTemplates().length>0"
              header="{{'bikeshop.message_templates.fittings' | translate}}">
              <table class="table iso-table">
                <tbody>
                  <tr *ngFor="let messageTemplate of getBikeFittingsTemplates()"
                    (click)="selectMessageType(messageTemplate)">
                    <td>
                      <div>
                        {{
                        messageTemplate.EventTag + '_title' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:
                        partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours
                        }
                        }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <span class="hubtiger-mail" [ngClass]="{'configured' : messageTemplate.IsActive}"></span>
                        <span class="hubtiger-sms"
                          [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                        <span class="hubtiger-whatsapp" *ngIf="whatsappConfiguredEnabled"
                          [ngClass]="{ 'not-syncd' : messageTemplate.WhatsappActive && !messageTemplate.WAStatus, 'configured' : messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'APPROVED', 'rejected':  messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'REJECTED', 'pending' : messageTemplate.WhatsappActive && messageTemplate.WAStatus && messageTemplate.WAStatus !== 'APPROVED' && messageTemplate.WAStatus !== 'REJECTED'}"></span>
                      </div>
                    </td>
                    <td>
                      <div>
                        {{
                        messageTemplate.EventTag + '_description' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths,
                        ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
                        WaitingDelayHours: partner.WaitingDelayHours
                        }
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
            <p-accordionTab [selected]="isExpanded" header="{{'bikeshop.message_templates.bike_sale' | translate}}"
              *ngIf="partner.PartnerType === 1 && getBikeSaleTemplates().length>0">
              <table class="table iso-table">
                <tbody>
                  <tr *ngFor="let messageTemplate of getBikeSaleTemplates()"
                    (click)="selectMessageType(messageTemplate)">
                    <td>
                      <div>
                        {{
                        messageTemplate.EventTag + '_title' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:
                        partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours
                        }
                        }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <span class="hubtiger-mail" [ngClass]="{'configured' : messageTemplate.IsActive}"></span>
                        <span class="hubtiger-sms"
                          [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                        <span class="hubtiger-whatsapp" *ngIf="whatsappConfiguredEnabled"
                          [ngClass]="{ 'not-syncd' : messageTemplate.WhatsappActive && !messageTemplate.WAStatus, 'configured' : messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'APPROVED', 'rejected':  messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'REJECTED', 'pending' : messageTemplate.WhatsappActive && messageTemplate.WAStatus && messageTemplate.WAStatus !== 'APPROVED' && messageTemplate.WAStatus !== 'REJECTED'}"></span>
                      </div>
                    </td>
                    <td>
                      <div>
                        {{
                        messageTemplate.EventTag + '_description' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths,
                        ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
                        WaitingDelayHours: partner.WaitingDelayHours
                        }
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
            <p-accordionTab [selected]="isExpanded" header="{{'bikeshop.message_templates.shop_rides' | translate}}"
              *ngIf="partner.PartnerType === 1 && getShopRidesTemplates().length>0">
              <table class="table iso-table">
                <tbody>
                  <tr *ngFor="let messageTemplate of getShopRidesTemplates()"
                    (click)="selectMessageType(messageTemplate)">
                    <td>
                      <div>
                        {{
                        messageTemplate.EventTag + '_title' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:
                        partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours
                        }
                        }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <span class="hubtiger-mail" [ngClass]="{'configured' : messageTemplate.IsActive}"></span>
                        <span class="hubtiger-sms"
                          [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                        <span class="hubtiger-whatsapp" *ngIf="whatsappConfiguredEnabled"
                          [ngClass]="{ 'not-syncd' : messageTemplate.WhatsappActive && !messageTemplate.WAStatus, 'configured' : messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'APPROVED', 'rejected':  messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'REJECTED', 'pending' : messageTemplate.WhatsappActive && messageTemplate.WAStatus && messageTemplate.WAStatus !== 'APPROVED' && messageTemplate.WAStatus !== 'REJECTED'}"></span>
                      </div>
                    </td>
                    <td>
                      <div>
                        {{
                        messageTemplate.EventTag + '_description' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths,
                        ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
                        WaitingDelayHours: partner.WaitingDelayHours
                        }
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
            <p-accordionTab [selected]="isExpanded" *ngIf="getCouponTemplates().length>0"
              header="{{'bikeshop.message_templates.coupons' | translate}}">
              <table class="table iso-table">
                <tbody>
                  <tr *ngFor="let messageTemplate of getCouponTemplates()" (click)="selectMessageType(messageTemplate)">
                    <td>
                      <div>
                        {{
                        messageTemplate.EventTag + '_title' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:
                        partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours
                        }
                        }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <span class="hubtiger-mail" [ngClass]="{'configured' : messageTemplate.IsActive}"></span>
                        <span class="hubtiger-sms"
                          [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                        <span class="hubtiger-whatsapp" *ngIf="whatsappConfiguredEnabled"
                          [ngClass]="{ 'not-syncd' : messageTemplate.WhatsappActive && !messageTemplate.WAStatus, 'configured' : messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'APPROVED', 'rejected':  messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'REJECTED', 'pending' : messageTemplate.WhatsappActive && messageTemplate.WAStatus && messageTemplate.WAStatus !== 'APPROVED' && messageTemplate.WAStatus !== 'REJECTED'}"></span>
                      </div>
                    </td>
                    <td>
                      <div>
                        {{
                        messageTemplate.EventTag + '_description' | translate : {
                        ServiceFollowUpReminderMonths:
                        partner.ServiceFollowUpReminderMonths,
                        ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
                        WaitingDelayHours: partner.WaitingDelayHours
                        }
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
            <p-accordionTab [selected]="isExpanded" *ngIf="getGiftCardTemplates().length>0"
              header=" {{'bikeshop.message_templates.giftcards' | translate }}">
              <table class="table iso-table">
                <tbody>
                  <tr *ngFor="let messageTemplate of getGiftCardTemplates()"
                    (click)="selectMessageType(messageTemplate)">
                    <td>
                      <div>
                        {{ messageTemplate.EventTag + '_title' | translate }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <span class="hubtiger-mail" [ngClass]="{'configured' : messageTemplate.IsActive}"></span>
                        <span class="hubtiger-sms"
                          [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                        <span class="hubtiger-whatsapp" *ngIf="whatsappConfiguredEnabled"
                          [ngClass]="{ 'not-syncd' : messageTemplate.WhatsappActive && !messageTemplate.WAStatus, 'configured' : messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'APPROVED', 'rejected':  messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'REJECTED', 'pending' : messageTemplate.WhatsappActive && messageTemplate.WAStatus && messageTemplate.WAStatus !== 'APPROVED' && messageTemplate.WAStatus !== 'REJECTED'}"></span>
                      </div>
                    </td>
                    <td>
                      <div>
                        {{ messageTemplate.EventTag + '_description' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
          </div>
          <div *ngIf="isRentals">
            <p-accordionTab [selected]="isExpanded" *ngIf="getRentalTemplates().length>0"
              header="{{'bikeshop.message_templates.rentals' |   translate }}">
              <table class="table iso-table">
                <tbody>
                  <tr *ngFor="let messageTemplate of getRentalTemplates()" (click)="selectMessageType(messageTemplate)">
                    <td>
                      <div>
                        {{ messageTemplate.EventTag + '_title' | translate }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <span class="hubtiger-mail" [ngClass]="{'configured' : messageTemplate.IsActive}"></span>
                        <span class="hubtiger-sms"
                          [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                        <span class="hubtiger-whatsapp" *ngIf="whatsappConfiguredEnabled"
                          [ngClass]="{ 'not-syncd' : messageTemplate.WhatsappActive && !messageTemplate.WAStatus, 'configured' : messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'APPROVED', 'rejected':  messageTemplate.WhatsappActive && messageTemplate.WAStatus == 'REJECTED', 'pending' : messageTemplate.WhatsappActive && messageTemplate.WAStatus && messageTemplate.WAStatus !== 'APPROVED' && messageTemplate.WAStatus !== 'REJECTED'}"></span>
                      </div>
                    </td>
                    <td>
                      <div class="footer-description">
                        {{ messageTemplate.EventTag + '_description' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
          </div>
        </p-accordion>
      </div>


    </div>
    <!-- <div class="row">
      <div class="col-md-2 label" style="margin-top:4px;">{{ 'bikeshop.menu.message_templates' | translate}}:</div>
      <div class="col-md-4 value">
        <p-listbox [options]="messageTemplates" [(ngModel)]="selectedMessageTemplate"
          (click)="showMessageType = true" styleClass="listbox-tall">
        </p-listbox>
      </div>
      <div class="col-md-6 margin-bottom-16">
        <div class="summary-container">
          <div class="content-container">
            <div *ngFor="let messageTemplate of messageTemplatesFull">
              <div class="configuration">
                <div class="message-template-name">
                  <div style="margin-right: auto;">{{ messageTemplate.EventTag }}</div>
                  <span class="hubtiger-mail"
                    [ngClass]="{'configured' : messageTemplate.IsActive}"></span>
                  <span class="hubtiger-sms" [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--    <div *ngIf="isWorkshop">-->
    <!--      <div class='menu-header'>{{'bikeshop.message_templates.services' | translate}}</div>-->
    <!--      <div class="menu-container">-->
    <!--        <div class="menu-card-container" *ngFor="let messageTemplate of getServiceTemplates()"-->
    <!--             (click)="selectMessageType(messageTemplate)">-->
    <!--          <div class="menu-card">-->
    <!--            <div class="menu-footer">-->
    <!--              <div class="flex">-->
    <!--                <div>-->
    <!--                  {{ appConfig.getCustomLabelForMessageTag(messageTemplate.EventTag, (messageTemplate.EventTag + '_title'-->
    <!--                  | translate : {-->
    <!--                  ServiceFollowUpReminderMonths:-->
    <!--                  partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:-->
    <!--                  partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours,-->
    <!--                  OtherServiceFollowUpReminderMonths: partner.OtherServiceFollowUpReminderMonths,-->
    <!--                  PostServiceFollowUpDays: partner.PostServiceFollowUpDays-->
    <!--                }), false) }}-->
    <!--                </div>-->
    <!--                <div>-->
    <!--                  <span class="hubtiger-mail"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.IsActive}"></span>-->
    <!--                  <span class="hubtiger-sms"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="footer-description">-->
    <!--                {{-->
    <!--                appConfig.getCustomLabelForMessageTag(messageTemplate.EventTag, (messageTemplate.EventTag-->
    <!--                + '_description' | translate : {-->
    <!--                  ServiceFollowUpReminderMonths:-->
    <!--                  partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService: partner.ReminderHoursBeforeService,-->
    <!--                  WaitingDelayHours: partner.WaitingDelayHours, OtherServiceFollowUpReminderMonths:-->
    <!--                  partner.OtherServiceFollowUpReminderMonths,-->
    <!--                  PostServiceFollowUpDays: partner.PostServiceFollowUpDays-->
    <!--                }), true)-->
    <!--                }}-->
    <!--              </div>-->
    <!--              &lt;!&ndash; <div class="margin-top-8">-->
    <!--              <span class="hubtiger-mail"-->
    <!--                [ngClass]="{'configured' : messageTemplate.IsActive}"></span>-->
    <!--              <span class="hubtiger-sms" [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>-->
    <!--            </div> &ndash;&gt;-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->


    <!--      <div class='menu-header' *ngIf="getBikeFittingsTemplates().length>0">-->
    <!--        {{-->
    <!--        'bikeshop.message_templates.fittings' |-->
    <!--          translate-->
    <!--        }}-->
    <!--      </div>-->
    <!--      <div class="menu-container">-->
    <!--        <div class="menu-card-container" *ngFor="let messageTemplate of getBikeFittingsTemplates()"-->
    <!--             (click)="selectMessageType(messageTemplate)">-->
    <!--          <div class="menu-card">-->
    <!--            <div class="menu-footer">-->
    <!--              <div class="flex">-->
    <!--                <div>-->
    <!--                  {{-->
    <!--                  messageTemplate.EventTag + '_title' | translate : {-->
    <!--                    ServiceFollowUpReminderMonths:-->
    <!--                    partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:-->
    <!--                    partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours-->
    <!--                  }-->
    <!--                  }}-->
    <!--                </div>-->
    <!--                <div>-->
    <!--                  <span class="hubtiger-mail"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.IsActive}"></span>-->
    <!--                  <span class="hubtiger-sms"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="footer-description">-->
    <!--                {{-->
    <!--                messageTemplate.EventTag + '_description' | translate : {-->
    <!--                  ServiceFollowUpReminderMonths:-->
    <!--                  partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService: partner.ReminderHoursBeforeService,-->
    <!--                  WaitingDelayHours: partner.WaitingDelayHours-->
    <!--                }-->
    <!--                }}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class='menu-header' *ngIf="partner.PartnerType === 1 && getBikeSaleTemplates().length>0">-->
    <!--        {{-->
    <!--        'bikeshop.message_templates.bike_sale' |-->
    <!--          translate-->
    <!--        }}-->
    <!--      </div>-->
    <!--      <div class="menu-container" *ngIf="partner.PartnerType === 1">-->
    <!--        <div class="menu-card-container" *ngFor="let messageTemplate of getBikeSaleTemplates()"-->
    <!--             (click)="selectMessageType(messageTemplate)">-->
    <!--          <div class="menu-card">-->
    <!--            <div class="menu-footer">-->
    <!--              <div class="flex">-->
    <!--                <div>-->
    <!--                  {{-->
    <!--                  messageTemplate.EventTag + '_title' | translate : {-->
    <!--                    ServiceFollowUpReminderMonths:-->
    <!--                    partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:-->
    <!--                    partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours-->
    <!--                  }-->
    <!--                  }}-->
    <!--                </div>-->
    <!--                <div>-->
    <!--                  <span class="hubtiger-mail"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.IsActive}"></span>-->
    <!--                  <span class="hubtiger-sms"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="footer-description">-->
    <!--                {{-->
    <!--                messageTemplate.EventTag + '_description' | translate : {-->
    <!--                  ServiceFollowUpReminderMonths:-->
    <!--                  partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService: partner.ReminderHoursBeforeService,-->
    <!--                  WaitingDelayHours: partner.WaitingDelayHours-->
    <!--                }-->
    <!--                }}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class='menu-header' *ngIf="getCouponTemplates().length>0">-->
    <!--        {{-->
    <!--        'bikeshop.message_templates.coupons' |-->
    <!--          translate-->
    <!--        }}-->
    <!--      </div>-->
    <!--      <div class="menu-container">-->
    <!--        <div class="menu-card-container" *ngFor="let messageTemplate of getCouponTemplates()"-->
    <!--             (click)="selectMessageType(messageTemplate)">-->
    <!--          <div class="menu-card">-->
    <!--            <div class="menu-footer">-->
    <!--              <div class="flex">-->
    <!--                <div>-->
    <!--                  {{-->
    <!--                  messageTemplate.EventTag + '_title' | translate : {-->
    <!--                    ServiceFollowUpReminderMonths:-->
    <!--                    partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:-->
    <!--                    partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours-->
    <!--                  }-->
    <!--                  }}-->
    <!--                </div>-->
    <!--                <div>-->
    <!--                  <span class="hubtiger-mail"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.IsActive}"></span>-->
    <!--                  <span class="hubtiger-sms"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="footer-description">-->
    <!--                {{-->
    <!--                messageTemplate.EventTag + '_description' | translate : {-->
    <!--                  ServiceFollowUpReminderMonths:-->
    <!--                  partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService: partner.ReminderHoursBeforeService,-->
    <!--                  WaitingDelayHours: partner.WaitingDelayHours-->
    <!--                }-->
    <!--                }}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class='menu-header' *ngIf="getGiftCardTemplates().length>0">-->
    <!--        {{'bikeshop.message_templates.giftcards' | translate }}-->
    <!--      </div>-->
    <!--      <div class="menu-container">-->
    <!--        <div class="menu-card-container" *ngFor="let messageTemplate of getGiftCardTemplates()"-->
    <!--             (click)="selectMessageType(messageTemplate)">-->
    <!--          <div class="menu-card">-->
    <!--            <div class="menu-footer">-->
    <!--              <div class="flex">-->
    <!--                <div>-->
    <!--                  {{ messageTemplate.EventTag + '_title' | translate }}-->
    <!--                </div>-->
    <!--                <div>-->
    <!--                  <span class="hubtiger-mail"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.IsActive}"></span>-->
    <!--                  <span class="hubtiger-sms"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="footer-description">-->
    <!--                {{ messageTemplate.EventTag + '_description' | translate }}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div *ngIf="isRentals">-->
    <!--      <div class='menu-header' *ngIf="getRentalTemplates().length>0">-->
    <!--        {{'bikeshop.message_templates.rentals' |   translate    }}-->
    <!--      </div>-->
    <!--      <div class="menu-container">-->
    <!--        <div class="menu-card-container" *ngFor="let messageTemplate of getRentalTemplates()"-->
    <!--             (click)="selectMessageType(messageTemplate)">-->
    <!--          <div class="menu-card">-->
    <!--            <div class="menu-footer">-->
    <!--              <div class="flex">-->
    <!--                <div>-->
    <!--                  {{ messageTemplate.EventTag + '_title' | translate }}-->
    <!--                </div>-->
    <!--                <div>-->
    <!--                  <span class="hubtiger-mail"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.IsActive}"></span>-->
    <!--                  <span class="hubtiger-sms"-->
    <!--                        [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="footer-description">-->
    <!--                {{ messageTemplate.EventTag + '_description' | translate }}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</div>


<p-sidebar #navSideBar [(visible)]="showMessageType" position="right"
  [style]="{width:'90em', background: '#F6F6F8', 'overflow-x': 'auto', 'max-width': '100%'}"
  (onHide)="navSideBar.destroyModal(); getMessageTemplates();">
  <div *ngIf="showMessageType">
    <app-message-type-panel [selectedMessageTemplate]="selectedMessageTemplate"
      [whatsappConfiguredEnabled]="whatsappConfiguredEnabled" [messageTemplates]="messageTemplatesFull"
      (closePanel)="closePanel()"></app-message-type-panel>
  </div>
</p-sidebar>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>